export const inferLabel = () => { };
